module.exports = __webpack_public_path__ + "img/defaultBook.50937db5.png";